import { ProductItem } from "../classes/ProductItem";

export function buildEcommerceItems(
	products: any,
	packCode: string,
	averageRatingPerLihe: number,
	reviewNumberPerLihe: string
):
	| {
			ecommerce: { items: ProductItem[] };
	  }
	| undefined {
	if (!products || !products.length) {
		throw new Error("products are mandatroy in buildEcommerceItems");
	}
	const {
		liheId,
		liheName,
		region,
		station,
		stationId,
		regionId,
		country,
		countryCode,
		variants,
	} = products[0];

	if (!variants)
		throw new Error("variants are mandatory in buildEcommerceItems");

	const { duration, startDate, endDate } = variants?.at(0);
	const prestIdsArr = buildProductPrestIdsArr(products);
	const prestNamesArr = buildProductPrestNamesArr(products);
	const ecommerceItems: ProductItem[] = [];
	const productItem = new ProductItem();

	// Assign values to its properties
	productItem.item_LiheId = liheId;
	productItem.item_LiheName = liheName;
	productItem.item_PrestIds = prestIdsArr;
	productItem.item_PrestNames = prestNamesArr;
	productItem.item_price_ati = "";
	productItem.item_category = region;
	productItem.item_category2 = station;
	productItem.item_category3 = ""; // Empty string for item_category3
	productItem.item_category4 = ""; // Empty string for item_category4
	productItem.item_variant = packCode;
	productItem.item_ville_name = station;
	productItem.item_ville_id = stationId || "";
	productItem.item_region_name = region || "";
	productItem.item_region_id = regionId || "";
	productItem.item_pays_name = country || "";
	productItem.item_pays_id = countryCode || "";
	(productItem.item_begin_date = new Intl.DateTimeFormat("fr-FR").format(
		new Date(startDate)
	)),
		(productItem.item_end_date = new Intl.DateTimeFormat("fr-FR").format(
			new Date(endDate)
		));
	productItem.item_duration = `${duration} days`;
	productItem.item_reviews_note =
		averageRatingPerLihe?.toFixed(1).toString() || "";
	productItem.item_reviews = reviewNumberPerLihe || "";
	productItem.position = 0;

	productItem.isValid();

	ecommerceItems.push(productItem);

	return {
		ecommerce: {
			items: ecommerceItems,
		},
	};
}

function buildProductPrestIdsArr(prestations: any): string[] {
	if (!prestations || !prestations.length)
		throw new Error("prestations are mandatory in buildProductPrestIdsArr");
	return prestations.map((prestation: any) => prestation.prestationId);
}

function buildProductPrestNamesArr(prestations: any): string[] {
	if (!prestations || !prestations.length)
		throw new Error("prestations are mandatory in buildProductPrestIdsArr");
	return prestations.map((prestation: any) => prestation.accomodationName);
}
